/**
 * dialogStore.js — Bar Experts
 * Substitui window.confirm() e window.prompt() (proibidos pelo DESIGN.md) por um
 * diálogo do próprio site, no tema certo e bom no celular. Mostrado por AppDialog.vue.
 *
 *   const dialog = useDialogStore()
 *   if (!(await dialog.confirm({ message: 'Excluir este item?', danger: true }))) return
 *   const motivo = await dialog.prompt({ message: 'Motivo da alteração:', defaultValue: '' })
 *   if (motivo === null) return   // cancelou
 */
import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useDialogStore = defineStore('dialog', () => {
  const current = ref(null)
  let resolver = null

  function open(options) {
    if (resolver) resolver(options.kind === 'prompt' ? null : false) // fecha um anterior pendente
    return new Promise((resolve) => {
      resolver = resolve
      current.value = {
        title: '',
        confirmText: options.kind === 'prompt' ? 'Salvar' : 'Confirmar',
        cancelText: 'Cancelar',
        danger: false,
        value: options.defaultValue ?? '',
        placeholder: '',
        ...options,
      }
    })
  }

  function confirm(options) {
    return open({ kind: 'confirm', ...(typeof options === 'string' ? { message: options } : options) })
  }

  function prompt(options) {
    return open({ kind: 'prompt', ...(typeof options === 'string' ? { message: options } : options) })
  }

  function close(result) {
    const done = resolver
    resolver = null
    current.value = null
    done?.(result)
  }

  return { current, confirm, prompt, close }
})
